"use strict";

var _toConsumableArray = require("E:\\Old Development\\tcCardOrder\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHaveFocus = toHaveFocus;

var _utils = require("./utils");

function toHaveFocus(element) {
  var _this = this;

  (0, _utils.checkHtmlElement)(element, toHaveFocus, this);
  return {
    pass: element.ownerDocument.activeElement === element,
    message: function message() {
      return [_this.utils.matcherHint("".concat(_this.isNot ? '.not' : '', ".toHaveFocus"), 'element', ''), ''].concat(_toConsumableArray(_this.isNot ? ['Received element is focused:', "  ".concat(_this.utils.printReceived(element))] : ['Expected element with focus:', "  ".concat(_this.utils.printExpected(element)), 'Received element with focus:', "  ".concat(_this.utils.printReceived(element.ownerDocument.activeElement))])).join('\n');
    }
  };
}